import React from 'react';
import RsvpUnit from 'mini-rsvp/lib/components/RsvpUnit';
import { getOnSuccessCallback } from '../utils/getOnSuccessCallback';
import { getOwaMiniStrings } from 'owa-strings/owa-mini-strings';
import { getPreventClickPropagationProps } from 'mini-accessibility/lib/utils/getPreventClickPropogationProps';
import { MAIL_LIST_VIEW } from 'data/lib/mini-app-constants/commonEventSourceConstants';
import { observer } from 'mobx-react-lite';
import { ReactAppSourceContext } from 'data/lib/utils/ReactAppSourceContext';
import { RsvpUnitSkeleton } from './RsvpUnitSkeleton';
import { RsvpUnitWrapperProps } from '../schema/RsvpUnitWrapper.types';
import { useCalendarEventFromMeetingItem } from '../hooks/useCalendarEventFromMeetingItem';

const styles = require('./RsvpUnitWrapper.scss');

const PREVENT_CLICK_PROPAGATION_PROPS = getPreventClickPropagationProps();

const RsvpUnitWrapper = (props: RsvpUnitWrapperProps) => {
    const {
        meetingClientItem,
        onDeleteSuccess,
        onRsvpActionSuccess,
        source,
        shouldFetchFullEvent = false,
        stopTapPropagation = false,
        onConversionToCalEvent,
        isActionable = true,
        tabIndex,
        removeCanceledEvent,
    } = props;

    const calendarEvent = useCalendarEventFromMeetingItem(
        meetingClientItem,
        shouldFetchFullEvent,
        onConversionToCalEvent
    );
    const strings = getOwaMiniStrings();

    const fetchConflictingMeetingsFinished =
        (meetingClientItem as any)?.ConflictingMeetingCount !== undefined;

    const showCalendarIconAndSecondaryTextPlaceholderUI =
        source === MAIL_LIST_VIEW &&
        !calendarEvent?.IsRecurring &&
        !calendarEvent?.IsCancelled &&
        !fetchConflictingMeetingsFinished;

    return calendarEvent ? (
        <ReactAppSourceContext.Provider value={source}>
            <div
                className={styles.rsvpUnitWrapperContainer}
                {...(stopTapPropagation ? PREVENT_CLICK_PROPAGATION_PROPS : {})}>
                <RsvpUnit
                    isActionable={isActionable}
                    item={calendarEvent}
                    tabIndex={tabIndex}
                    onDeleteServiceCompletion={getOnSuccessCallback(
                        onDeleteSuccess,
                        strings.onDeleteEventSuccessAriaLabel
                    )}
                    onRsvpActionServiceCompletion={getOnSuccessCallback(
                        onRsvpActionSuccess,
                        strings.onRsvpActionSuccessAriaLabel
                    )}
                    originalMeetingMessage={meetingClientItem}
                    shouldDeleteMailItemFromServer={true}
                    removeCanceledEvent={removeCanceledEvent}
                    showCalendarIconAndSecondaryTextPlaceholderUI={
                        showCalendarIconAndSecondaryTextPlaceholderUI
                    }
                />
            </div>
        </ReactAppSourceContext.Provider>
    ) : (
        <RsvpUnitSkeleton />
    );
};

export default observer(RsvpUnitWrapper);
